module.exports = __webpack_public_path__ + "img/AstroFrens80.cc389505.jpg";